export const getBusinessNotificationsUrl = () => 'business/notifications';
export const getBusinessNotificationsUnreadCountUrl = () => 'business/notifications/unread_count';
export const getBusinessNotificationsMarkAllReadUrl = () => 'business/notifications/mark_all_read';
export const getBusinessNotificationMarkReadUrl = (id: number) => `business/notifications/${id}`;
